export default "__VITE_ASSET__jN0_htH8__"